export const getServicesData = ({
  props: {
    children: {
      props: {
        services: {
          popularServices = [],
          servicesCategory = []
        } = {}
      } = {}
    } = {}
  } = {}
}) =>
  ({ popularServices, servicesCategory })

export const getPromotionsData = ({
  props: {
    children: {
      props: {
        services: {
          promotionsDetails = []
        } = {}
      } = {}
    } = {}
  } = {}
}) =>
  ({ promotionsDetails })

export const getPromoExcludedData = ({
  props: {
    children: {
      props: {
        services: {
          promoExcluded = true
        } = {}
      } = {}
    } = {}
  } = {}
}) =>
  ({ promoExcluded })

export const formatPopularServiceItems = (popularServices = []) =>
  popularServices.map(({ skuId, displayName, averageSalePrice, autoSelect }) => ({
    label: displayName,
    value: skuId,
    revenue: averageSalePrice,
    autoSelect
  }))

export const getNumberOfSelectedServices = (selectedServices = [], categoryServices = []) =>
  categoryServices
    .map(({ value }) => value)
    .filter(value => selectedServices.includes(value))
    .length
